const UI_ERR_COULD_NOT_LOAD = 'Could not load.';
const UI_ERR_OOPS = 'Oops...';
const UI_ERR_TRY_AGAIN = 'Try Again';

export { UI_ERR_COULD_NOT_LOAD, UI_ERR_OOPS, UI_ERR_TRY_AGAIN };
